export enum ReturnRejectedItemIndicator {
    Blank = "Blank",
    ScrapForDealer = "ScrapForDealer",
    ReturnToDealer = "ReturnToDealer",
}
